import { getFields } from '@/features/AudienceManager/services';
import { valueType } from '@/utilities/constants';
import { isEmpty } from 'lodash';
export const fetchConfigConnectors = (params) => {
    return getFields(params).then(response => formatValue(response?.data));
};
const formatValue = (response) => {
    const audienceFields = response?.data?.audience;
    const isAudienceFieldsString = typeof audienceFields === valueType.string;
    const hasValidAudienceFields = !isAudienceFieldsString && !isEmpty(audienceFields);
    const formattedAudienceFields = hasValidAudienceFields
        ? Array.isArray(audienceFields) &&
            audienceFields.map(field => {
                const hasOptions = field.type === 'select' && field.options?.length > 0;
                const defaultOptionId = hasOptions ? field.options[0].id : '';
                return {
                    ...field,
                    defaultOption: defaultOptionId,
                };
            })
        : [];
    return {
        audience: formattedAudienceFields,
        hasConfig: Boolean(response?.data.configuration.length),
        instances: response?.data?.instances,
        success: Boolean(response?.success),
    };
};
